import { render } from "./information.vue?vue&type=template&id=dbd74f8c&ts=true"
import script from "./information.vue?vue&type=script&lang=ts"
export * from "./information.vue?vue&type=script&lang=ts"

import "./information.vue?vue&type=style&index=0&id=dbd74f8c&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__